import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import * as rubrosActions from '../../reducers/rubrosReducer/actions'
import { rubrosDataSelector } from '../../selectors/rubrosSelector'
import * as articuloActions from '../../reducers/articuloReducer/actions'
import { articuloDataSelector } from '../../selectors/articuloSelector'
import * as Notification from '../../components/Common/notification'
import ArticuloGenericoNuevo from '../../components/Articulo/articuloGenericoNuevo'
import { compress, calculateNewSize } from '../../components/Common/imageCompressor'
import { usuarioSelector } from '../../selectors/sessionSelector'
import { GetOfertasActivas } from '../../sagas/ofertaSaga/calls'
import { GetProveedor } from '../../sagas/proveedorSaga/calls'
import { GetAllMarcas } from '../../sagas/marcaSaga/calls'


class ArticuloGenericoNuevoContainer extends React.Component {
    constructor(props) {
        super(props)

        let idTemporalEdition = Math.floor(1000 + Math.random() * 9000);

        this.state = {
            update: false,
            currentFiles: {},
            idTemporal: idTemporalEdition,
            errorDescription: {},
            valid: true,
            openModalImagen: false,
            clearState: false,
            pathRecorteActual: undefined,
            imagenOriginal: undefined,
            articulo: {
                nombre: '',
                articuloAlternativa: [],
                articuloFiltro: [],
                cantidadLimMax: 0,
                cantidadLimMin: 0,
                codigoBarra: '',
                datosExtra: '',
                fechaRegistro: '',
                incremento: 0,
                marca: [],
                precioPromocional: '',
                precio: '',
                porcentajeImpuestosNacionales: 0,
                idSubrubro: 0,
                imgSrc: [],
                codigoInterno: '',
                stock: 0,
                stockGenerico: 0,
                descripcion: '',
                etiquetas: [],
                proveedor: '',
                productoPesable: false,
                oferta: []
            },
            ofertas: [],
            error: null,
            proveedor: [],
            marca: [],
            campoAlternativa: '',
            campoEtiqueta: '',
            campoCaracteristica: ''
        }

        if (this.props.rubros.rubros === undefined)
            this.props.history.push('/Articulo');

        let payload = {};
        payload.id = this.props.match.params.idArticulo
        //idTemporalEdition= Math.floor(1000 + Math.random() * 9000)    
        payload.idTemporalEdition = this.state.idTemporal

        if (this.props.match.params.idArticulo !== undefined) {
            this.setState({
                update: true
            })
            //this.props.sagaGetSubRubros(this.props.match.params.idArticulo,null,true);
            this.props.sagaGetArticuloCompleto(payload)
        }


    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.match.params.idArticulo !== undefined &&
            nextProps.dataArticulo.articuloCompleto !== undefined &&
            nextProps.dataSubrubro.subrubros !== undefined) {

            let newStock = nextProps.dataArticulo.articuloCompleto.stock;
            let newStockGenerico = nextProps.dataArticulo.articuloCompleto.stockGenerico;
            let imgTemp = nextProps.dataArticulo.articuloCompleto.listaImagenesArticulos.map(item =>
                item.miniatura ? { ...item, selected: true } : item
            );

            this.setState({
                ...this.state,
                articulo: {
                    ...this.state.articulo,
                    stock: newStock,
                    stockGenerico: newStockGenerico,
                    imgSrc: imgTemp,
                    nombre: nextProps.dataArticulo.articuloCompleto.nombre,
                    precio: nextProps.dataArticulo.articuloCompleto.precioLista,
                    porcentajeImpuestosNacionales: nextProps.dataArticulo.articuloCompleto.porcentajeImpuestosNacionales || 0,
                    idSubrubro: nextProps.dataArticulo.articuloCompleto.subrubroClass.idSubRubro || 0,
                    idTipoTalle: nextProps.dataArticulo.articuloCompleto.tipoTalle.idTipoTalle || 0,
                    codigoInterno: nextProps.dataArticulo.articuloCompleto.codigoInterno,
                    etiquetas: nextProps.dataArticulo.articuloCompleto.etiquetas || [],
                    marca: nextProps.dataArticulo.articuloCompleto.marca || [],
                    cantidadLimMax: nextProps.dataArticulo.articuloCompleto.cantidadLimMax || 0,
                    cantidadLimMin: nextProps.dataArticulo.articuloCompleto.cantidadLimMin || 0,
                    datosExtra: nextProps.dataArticulo.articuloCompleto.datosExtra || '',
                    precioPromocional: nextProps.dataArticulo.articuloCompleto.precioPromocional || '',
                    incremento: nextProps.dataArticulo.articuloCompleto.incremento || 0,
                    codigoBarra: nextProps.dataArticulo.articuloCompleto.codigoBarra,
                    articuloFiltro: nextProps.dataArticulo.articuloCompleto.articuloFiltro
                        ? nextProps.dataArticulo.articuloCompleto.articuloFiltro
                        : [],
                    articuloAlternativa: nextProps.dataArticulo.articuloCompleto.articuloAlternativa || [],
                    proveedor: nextProps.dataArticulo.articuloCompleto.proveedor || '',
                    productoPesable: nextProps.dataArticulo.articuloCompleto.productoPesable || false,
                    oferta: nextProps.dataArticulo.articuloCompleto.oferta || [],
                    descripcion: nextProps.dataArticulo.articuloCompleto.descripcion || ''
                },
                articuloCargado: true
            });
        }
    }

    componentDidMount() {
        GetOfertasActivas()
            .then((data) => {
                this.setState({ ofertas: data });
            })
            .catch((error) => {
                this.setState({ error });
            });

        GetProveedor()
            .then((data) => {
                this.setState({ proveedor: data });
            })
            .catch((error) => {
                this.setState({ error });
            });

        GetAllMarcas()
            .then((data) => {
                this.setState({ marca: data });
            })
            .catch((error) => {
                this.setState({ error });
            });
    }

    componentDidUpdate(prevProps, prevState) {
        if (!prevState.usuarioCargado && this.props.usuario !== undefined) {
            this.setState({ usuarioCargado: true }, () => {
                if (this.props.usuario.idRol === 4) {
                    window.location.hash = '/Pedidos';
                }
            });
        }

        if (this.props.dataArticulo.articuloCompleto !== prevProps.dataArticulo.articuloCompleto) {
            if (!prevState.articuloCargado) {
                this.setState({ articuloCargado: true }, this.guardarStockOriginal);
            }

            if (!prevState.imagenesCargadas) {
                this.setState({ imagenesCargadas: true }, this.getImagenesArticulo);
            }

            if (this.props.dataArticulo.cantidadImagenesCargadas !== prevState.cantidadImagenesCargadas) {
                this.setState({ cantidadImagenesCargadas: this.props.dataArticulo.cantidadImagenesCargadas }, this.actualizarImagenesArticulo);
            }

            if (this.props.dataArticulo.cantidadImagenesOriginalesCargadas !== prevState.cantidadImagenesOriginalesCargadas) {
                this.setState({ cantidadImagenesOriginalesCargadas: this.props.dataArticulo.cantidadImagenesOriginalesCargadas }, this.actualizarImaganesOriginalesArticulo);
            }
        }
    }


    handleMarcaChange = (valorMarca) => {
        const marcaSeleccionada = this.state.marca.find(m => m.idMarca === valorMarca);

        if (marcaSeleccionada) {
            let articulo = { ...this.state.articulo };
            this.setState({
                articulo: {
                    ...articulo,
                    marca: marcaSeleccionada
                }
            });
        }
    }

    handleProveedorChange = (valorProveedor) => {
        const proveedorSeleccionado = this.state.proveedor.find(p => p.idProveedor === valorProveedor);

        if (proveedorSeleccionado) {
            let articulo = { ...this.state.articulo };
            this.setState({
                articulo: {
                    ...articulo,
                    proveedor: proveedorSeleccionado
                }
            });
        }
    }

    handleOfertaChange = (valorOferta) => {
        console.log("Oferta seleccionada:", valorOferta);

        if (valorOferta === '') {
            this.setState({
                articulo: {
                    ...this.state.articulo,
                    oferta: []
                },
                selectedOferta: ''
            })
        } else {
            const ofertaSeleccionada = this.state.ofertas.find(o => o.idOferta === valorOferta);
    
            if (ofertaSeleccionada) {
                let articulo = { ...this.state.articulo };
                this.setState({
                    articulo: {
                        ...articulo,
                        oferta: ofertaSeleccionada
                    },
                    selectedOferta: valorOferta
                });
            }
        }

    }

    handleOnChangePrecio = (values) => {
        const { floatValue } = values;
        this.setState(prevState => ({
            articulo: {
                ...prevState.articulo,
                precio: floatValue !== undefined ? floatValue : ''
            }
        }));
    }

    handleOnChangePrecioPromocional = (values) => {
        const { floatValue } = values;
        this.setState(prevState => ({
            articulo: {
                ...prevState.articulo,
                precioPromocional: floatValue !== undefined ? floatValue : ''
            }
        }));
    }

    handleOnChangePorcentajeImpuestosNacionales= (values) => {
        console.log('Seba handleOnChangePorcentajeImpuestosNacionales')
        const { floatValue } = values;
        this.setState(prevState => ({
            articulo: {
                ...prevState.articulo,
                porcentajeImpuestosNacionales: floatValue !== undefined ? floatValue : ''
            }
        }));
    }

    handleOnChangeOferta = (event) => {
        console.log("Valor seleccionado:", event.target.value);
        this.setState({ selectedOferta: event.target.value });
    }

    handleDatosExtraChange = (event) => {
        let articulo = { ...this.state.articulo }
        articulo.datosExtra = event.target.value
        this.setState({
            articulo: articulo
        });
    }

    handleCaracteristicasProductoChange = (event) => {
        let articulo = { ...this.state.articulo }
        this.setState({
            articulo: {
                ...articulo,
                articuloFiltro: event.target.value
            }
        });
    }

    handleProductoPesableChange = (event) => {
        if (event.target) {
            let articulo = { ...this.state.articulo }
            this.setState({
                articulo: {
                    ...articulo,
                    productoPesable: event.target.checked
                }
            });
        }
    }

    handleIncrementoChange = (event) => {
        let articulo = { ...this.state.articulo }
        this.setState({
            articulo: {
                ...articulo,
                incremento: event.target.value
            }
        });
    }

    handleCantidadMinimaChange = (event) => {
        let articulo = { ...this.state.articulo }
        this.setState({
            articulo: {
                ...articulo,
                cantidadLimMin: event.target.value
            }
        });
    }

    handleCantidadMaximaChange = (event) => {
        let articulo = { ...this.state.articulo }
        this.setState({
            articulo: {
                ...articulo,
                cantidadLimMax: event.target.value
            }
        });
    }

    handleOnCodigoBarra = (e) => {
        let articulo = { ...this.state.articulo }
        articulo.codigoBarra = e.target.value
        this.setState({
            articulo: articulo
        })
    }

    handleOnNombre = (e) => {
        let articulo = { ...this.state.articulo }
        articulo.nombre = e.target.value
        this.setState({
            articulo: articulo
        })
    }

    handleOnCodigoInterno = (e) => {
        let articulo = { ...this.state.articulo }
        articulo.codigoInterno = e.target.value
        this.setState({
            articulo: articulo
        })
    }


    handleOnPrecio = (precio) => {
        let articulo = Object.assign({}, this.state.articulo);
        articulo.precio = precio;
        this.setState({ articulo: articulo });
    }


    handleOnSubrubro = (e) => {
        let articulo = { ...this.state.articulo }
        articulo.idSubrubro = e.target.value
        this.setState({
            articulo: articulo
        })
    }

    handleOnStock = (e) => {
        let articulo = { ...this.state.articulo }
        articulo.stock = e.target.value
        articulo.stockGenerico = e.target.value
        this.setState({
            articulo: articulo
        })
    }


    handleOnDropFile = acceptedFiles => {
        if (acceptedFiles.length > 0) {
            acceptedFiles.forEach(item => {
                let img = new Image();
                img.onload = () => {
                    let newSize = calculateNewSize(img.width, img.height, 750 * 2, 1125 * 2);
                    compress(item, item.name, newSize.width, newSize.height, this.onImageCompressed);
                };
                img.src = URL.createObjectURL(item);
            });
        }
    };

    onImageCompressed = (currentFile, base64) => {
        let fileUrl = URL.createObjectURL(currentFile);
        let newImgSrc = [...this.state.articulo.imgSrc];
        newImgSrc.push({
            path: "original_" + currentFile.name,
            pathImagen: base64,
            selected: false,
            idArticuloImagenes: 0,
            orden: newImgSrc.length > 0 ? newImgSrc.length + 1 : 1,
            Miniatura: false
        });

        let currentFiles = { ...this.state.currentFiles };
        currentFiles["original_" + currentFile.name] = fileUrl;

        this.setState({
            ...this.state,
            articulo: {
                ...this.state.articulo,
                imgSrc: newImgSrc
            },
            currentFiles: currentFiles
        });
    };


    handleCheckboxChange = (i, event) => {

        let imgSrc = this.state.articulo.imgSrc
        imgSrc[i.i].selected = !this.state.articulo.imgSrc[i.i].selected
        imgSrc[i.i].miniatura = imgSrc[i.i].selected
        let articulo = Object.assign({}, this.state.articulo);
        articulo.imgSrc = imgSrc;
        this.setState({ articulo: articulo });
    }

    handleOnChangeOrderArticuloImagenes = (from, to) => {
        let articulo = { ...this.state.articulo };
        let auxImg = articulo.imgSrc[to];
        articulo.imgSrc[to] = articulo.imgSrc[from];
        articulo.imgSrc[from] = auxImg;
        articulo.imgSrc[to].orden = to + 1;
        articulo.imgSrc[from].orden = from + 1;

        this.setState({
            articulo: articulo
        });
    };


    handleEliminarImagenArticulo = indice => {
        let articulo = { ...this.state.articulo };
        let imagenes = articulo.imgSrc.filter((item, index) => index !== indice);
        articulo.imgSrc = imagenes;

        this.setState({
            articulo: articulo
        });
    };
    handleOnOpenCropperModal = articuloImagen => {
        if (articuloImagen === undefined) return;

        let imgPath = articuloImagen.path;
        let position = imgPath.search("original_");
        let pathRecorteActual = imgPath;

        if (position === 0) {
            this.setState({
                openModalImagen: true,
                imagenOriginal: this.state.currentFiles[imgPath],
                pathRecorteActual: pathRecorteActual
            });
        } else {
            let path = 'original_' + imgPath;
            pathRecorteActual = path;
            let imagen = this.state.currentFiles[path];

            if (imagen === undefined) {
                this.props.sagaGetArticuloImagen({
                    idArticuloImagen: articuloImagen.idImagen,
                    recorte: false
                });
                this.setState({ articuloImagenModal: articuloImagen });
            } else {
                this.setState({
                    openModalImagen: true,
                    imagenOriginal: imagen,
                    pathRecorteActual: pathRecorteActual
                });
            }
        }
    };

    handleOnDescripcion = (e) => {
        let articulo = { ...this.state.articulo }
        articulo.descripcion = e
        this.setState({
            articulo: articulo
        })
    }

    handleOnSave = () => {
        let valido = this.validar()
        if (valido.valid === false) {
            this.setState({
                valid: false,
                errorDescription: valido.errorDescription,
            })
        }
        else {
            this.setState({
                valid: true,
                errorDescription: ''
            })

            this.handleSaveConfirmation()
        }
    }

    handleSaveConfirmation = () => {

        let datosRubro = Number(this.props.match.params.idRubro)
        // genero el payload

        let articuloAlta = {

            IdArticulo: (this.props.dataArticulo !== undefined && this.props.dataArticulo.articuloCompleto !== undefined) ? this.props.dataArticulo.articuloCompleto.idArticulo : 0, //para el alta
            IdInstalacion: 3,
            IdRubro: datosRubro,
            IdSubrubro: this.state.articulo.idSubrubro,
            Nombre: this.state.articulo.nombre,
            PrecioLista: this.state.articulo.precio,
            codigoInterno: this.state.articulo.codigoInterno,
            FechaRegistro: this.state.edicion === true ? this.props.dataArticulo.articuloCompleto.fechaRegistro : new Date(),
            UsuarioRegistro: this.props.usuario ? this.props.usuario.id : undefined,
            Activo: 1,
            ArticuloImagenes: this.state.articulo.imgSrc,
            Etiquetas: this.state.articulo.etiquetas,
            StockCantidad: this.state.articulo.stockGenerico,
            idTemporal: this.idTemporalEdition !== undefined ? this.idTemporalEdition : this.state.idTemporal,
            idMarca: this.state.articulo.marca.idMarca,
            idProveedor: this.state.articulo.proveedor.idProveedor,
            ProductoPesable: this.state.articulo.productoPesable,
            Incremento: this.state.articulo.incremento,
            PrecioPromocional: this.state.articulo.precioPromocional,
            PorcentajeImpuestosNacionales: this.state.articulo.porcentajeImpuestosNacionales,
            CantidadLimMax: this.state.articulo.cantidadLimMax,
            CantidadLimMin: this.state.articulo.cantidadLimMin,
            DatosExtra: this.state.articulo.datosExtra,
            ArticuloFiltro: this.state.articulo.articuloFiltro,
            ArticuloAlternativa: this.state.articulo.articuloAlternativa,
            CodigoBarra: this.state.articulo.codigoBarra,
            idOferta: this.state.articulo.oferta.idOferta,
            Descripcion: this.state.articulo.descripcion,
            afterSaveArticulo: this.afterSaveArticulo
        }

        // guardamos el articulo
        this.props.sagaSaveArticuloGenerico(articuloAlta)

        // si el usuario modificó el subrubro del articulo actualizo el catalogoCompleto en el reductor

        if (this.state.idSubRubroInicial !== undefined && articuloAlta.IdSubrubro !== this.state.idSubRubroInicial) {
            let subRubroNuevo
            this.props.dataSubrubro.subrubros.forEach((s) => {
                if (s.idSubrubro === articuloAlta.IdSubrubro) {
                    subRubroNuevo = s
                }
            })
            let payload = {
                idArticulo: articuloAlta.IdArticulo,
                subRubroNuevo: subRubroNuevo
            }
            this.props.cambiarArticuloDeSubRubro(payload)
        }
    }

    afterSaveArticulo = () => {

        // actualizo el estado
        this.setState({
            saved: true,
            valid: true
        })

        Notification.showSuccess("Artículo guardado exitosamente")
        this.limpiarFiltros()

        if (this.props.dataArticulo && this.props.dataArticulo.filtrosArticulo) {
            this.props.setFilterBusquedaArticulo(this.props.dataArticulo.filtrosArticulo)
        }
        this.props.history.push('/Articulo')
        /*
        // muestro mensaje de éxito
        if (this.props.dataArticulo !== undefined) // Modificar esto cuando se llegue al momento de crear la edicion
        {
            Notification.showSuccess("Artículo modificado exitosamente")
            this.props.history.push(`/Catalogo/catalogoEdicion/${this.props.dataCatalogo.catalogoCompleto.idCatalogo}/${this.props.dataArticulo.articuloCompleto !== undefined ? this.props.dataArticulo.articuloCompleto.idArticulo : true}`)
            //seteo articulo completo en undefined por problemas de setstate(ya que hacer al hacer click en otro articulo muchas veces quedaba cargado el anterior)
            this.props.setArticuloCompleto(undefined)
        }
        else
        {
            
            
            this.limpiarFiltros()
        }
        */
    }

    limpiarFiltros = () => {

        let articulo = { ...this.state.articulo }
        articulo.nombre = ''
        articulo.precio = ''
        articulo.stock = []
        articulo.stockGenerico = ''
        articulo.imgSrc = []
        articulo.codigoInterno = ''
        articulo.descripcion = ''
        articulo.etiquetas = []

        this.setState({
            articulo: articulo,
            clearState: true
        })
    }

    validar = () => {
        let articulo = { ...this.state.articulo }
        let valid = true
        let errorDescription = {}

        if (articulo.nombre === '') {
            valid = false
            errorDescription.errorNombre = "Por favor ingrese un nombre válido"
        }

        if (articulo.nombre.length > 255) {
            valid = false
            errorDescription.errorNombre = "Por favor ingrese un nombre válido"
            Notification.showError("Nombre con demasiados caracteres.")
        }

        if (articulo.precio === '' || isNaN(articulo.precio)) {
            valid = false
            errorDescription.errorPrecio = "Por favor ingrese un precio válido"
        }

        if (articulo.precio.length > 255) {
            valid = false
            errorDescription.errorPrecio = "Por favor ingrese un precio válido"
            Notification.showError("Precio con demasiados caracteres.")
        }

        if (articulo.idSubrubro === 0) {
            valid = false
            errorDescription.errorSubrubro = "Por favor, ingrese un subrubro"
        }

        if (!this.state.articulo.marca || !this.state.articulo.marca.idMarca) {
            valid = false
            errorDescription.errorMarca = "Por favor, ingrese una marca válida"
        }

        /*if (articulo.imgSrc.length === 0){       
                        valid=false
                        errorDescription.errorImagen="Por favor ingrese al menos una imagen"
                        Notification.showError("Por favor ingrese al menos una imagen")
                        }*/

        this.setState({ articulo: articulo })
        return { valid, errorDescription }
    }

    handleOnCloseCropperModal = () => {
        this.setState({ openModalImagen: false })
    }

    onChangeFalseEditorState = () => {

        this.setState({
            clearState: false
        })
    }




    onArticuloImageCompressed = currentFile => {
        let payload = {
            file: currentFile,
            idTemporal: this.state.idTemporal
        };
        this.props.sagaGetArticuloImagen(payload);
    };

    handleOnSaveImagenCortada = (recorte, blobData, imageData) => {
        if (this.state.openModalImagenTalleColor) {
            // Obtengo el nombre de archivo
            let fileName = this.state.pathTalleColor;

            // Comprimo la imagen
            let newSize = calculateNewSize(imageData.width, imageData.height, 30, 30);
            compress(blobData, fileName, newSize.width, newSize.height, this.onTalleColorImagenCompressed);
        } else {
            // Obtengo el nombre de archivo
            let fileName = this.state.pathRecorteActual.split('original_')[1];

            // Comprimo la imagen
            let newSize = calculateNewSize(imageData.width, imageData.height, 700, 1050); // Ajusto el tamaño para mejorar la calidad

            // Tomo el blob y lo comprimo
            fetch(recorte)
                .then(r => r.blob())
                .then(r => {
                    compress(r, fileName, newSize.width, newSize.height, this.onArticuloImageCompressed);
                });
        }
    };

    handleOnCancel = () => {
        if (this.props.dataArticulo && this.props.dataArticulo.filtrosArticulo) {
            this.props.setFilterBusquedaArticulo(this.props.dataArticulo.filtrosArticulo)
        }

        this.props.history.push('/Articulo')
    };

    getImagenesArticulo = () => {
        let articulo = this.props.dataArticulo.articuloCompleto
        // busco los recortes de las imágenes de los articulos
        for (var i = 0; i < articulo.listaImagenesArticulos.length; i++) {

            let idImagen = articulo.listaImagenesArticulos[i].idImagen
            let flag = true
            //Si la imagen ya existe en el reductor seteo flag en false y no se vuelve a pedir
            if (this.props.imagenesArticulo !== undefined) {
                this.props.imagenesArticulo.forEach((ai) => {
                    if (ai.idArticuloImagen === idImagen) {
                        flag = false
                    }
                })
            }
            //busco la imagen segun el flag 
            if (flag) {
                this.props.sagaGetArticuloImagen({
                    idArticuloImagen: articulo.listaImagenesArticulos[i].idImagen,
                    recorte: true
                })
            }
        }

    }

    handleDeleteAlternativa = (alternativa) => {
        let articulo = { ...this.state.articulo };
        articulo.articuloAlternativa = articulo.articuloAlternativa.filter(x => x.alternativa !== alternativa);

        this.setState({ articulo: articulo });
    }


    handleDelete = (etiqueta) => {
        let articulo = { ...this.state.articulo }

        articulo.etiquetas = articulo.etiquetas.filter(x => x.etiqueta !== etiqueta)
        this.setState({ articulo: articulo })
    }

    handleDeleteCaracteristica = (filtro) => {
        let articulo = { ...this.state.articulo };
        articulo.articuloFiltro = articulo.articuloFiltro.filter(x => x.filtro !== filtro);

        this.setState({ articulo: articulo });
    }

    handleOnCampoEtiqueta = (e) => {
        let value = e.target.value

        this.setState({ campoEtiqueta: value })
    }

    handleOnAddEtiqueta = () => {
        if (this.state.campoEtiqueta === undefined || this.state.campoEtiqueta === "" || this.state.campoEtiqueta === null) {
            return
        }

        let value = this.state.campoEtiqueta
        let articulo = { ...this.state.articulo }

        let e = articulo.etiquetas.find(x => x.etiqueta === value)
        if (e === undefined) {
            let etiqueta = {}
            etiqueta.etiqueta = value
            etiqueta.etiquetaManual = true
            articulo.etiquetas.push(etiqueta)

            this.setState({ articulo: articulo, campoEtiqueta: '' })
        }
    }

    handleOnCampoAlternativa = (e) => {
        let value = e.target.value

        this.setState({ campoAlternativa: value })
    }

    handleOnAddAlternativa = () => {
        if (this.state.campoAlternativa === undefined || this.state.campoAlternativa === "" || this.state.campoAlternativa === null) {
            console.log(this.state.campoAlternativa)
            return
        }

        let value = this.state.campoAlternativa
        let articulo = { ...this.state.articulo }

        let e = articulo.articuloAlternativa.find(x => x.alternativa === value)
        if (e === undefined) {
            let alternativa = {}
            alternativa.alternativa = value
            articulo.articuloAlternativa.push(alternativa)

            this.setState({ articulo: articulo, campoAlternativa: '' })
        }
    }

    handleOnCampoCaracteristica = (e) => {
        let value = e.target.value;
        
        this.setState({ campoCaracteristica: value });
    }

    handleOnAddCaracteristica = () => {
        const { campoCaracteristica } = this.state;

        if (campoCaracteristica === undefined || campoCaracteristica === "" || campoCaracteristica === null) {
            console.log(campoCaracteristica);
            return;
        }

        let value = campoCaracteristica;
        let articulo = { ...this.state.articulo };

        let e = articulo.articuloFiltro.find(x => x.filtro === value);
        if (e === undefined) {
            let filtro = {};
            filtro.filtro = value;
            articulo.articuloFiltro.push(filtro);

            this.setState({ articulo: articulo, campoCaracteristica: '' });
        }
    }

    render() {
        const { ofertas, proveedor, marca } = this.state;

        return (
            <ArticuloGenericoNuevo
                articulo={this.state.articulo}
                marcas={marca}
                proveedor={proveedor}
                rubros={this.props.rubros}
                match={this.props.match}
                subrubros={this.props.dataSubrubro.subrubros}
                campoEtiqueta={this.state.campoEtiqueta}
                campoAlternativa={this.state.campoAlternativa}
                handleOnNombre={this.handleOnNombre}
                handleOnPrecio={this.handleOnPrecio}
                handleOnCodigoInterno={this.handleOnCodigoInterno}
                handleOnSubrubro={this.handleOnSubrubro}
                handleOnStock={this.handleOnStock}
                handleOnDropFile={this.handleOnDropFile}
                handleCheckboxChange={this.handleCheckboxChange}
                handleEliminarImagenArticulo={this.handleEliminarImagenArticulo}
                handleOnOpenCropperModal={this.handleOnOpenCropperModal}
                handleOnCloseCropperModal={this.handleOnCloseCropperModal}
                handleOnChangeOrderArticuloImagenes={this.handleOnChangeOrderArticuloImagenes}
                handleOnDescripcion={this.handleOnDescripcion}
                handleMarcaChange={this.handleMarcaChange}
                handleProveedorChange={this.handleProveedorChange}
                handleOfertaChange={this.handleOfertaChange}
                handleOnChangePrecio={this.handleOnChangePrecio}
                handleOnChangePrecioPromocional={this.handleOnChangePrecioPromocional}
                handleOnChangePorcentajeImpuestosNacionales={this.handleOnChangePorcentajeImpuestosNacionales}
                handleOnChangeOferta={this.handleOnChangeOferta}
                handleDatosExtraChange={this.handleDatosExtraChange}
                handleCaracteristicasProductoChange={this.handleCaracteristicasProductoChange}
                handleProductoPesableChange={this.handleProductoPesableChange}
                handleIncrementoChange={this.handleIncrementoChange}
                handleCantidadMinimaChange={this.handleCantidadMinimaChange}
                handleCantidadMaximaChange={this.handleCantidadMaximaChange}
                handleOnCodigoBarra={this.handleOnCodigoBarra}
                handleOnSave={this.handleOnSave}
                handleOnCancel={this.handleOnCancel}
                handleDelete={this.handleDelete}
                handleDeleteAlternativa={this.handleDeleteAlternativa}
                handleDeleteCaracteristica={this.handleDeleteCaracteristica}
                handleOnCampoEtiqueta={this.handleOnCampoEtiqueta}
                handleOnAddEtiqueta={this.handleOnAddEtiqueta}
                handleOnAddAlternativa={this.handleOnAddAlternativa}
                handleOnAddCaracteristica={this.handleOnAddCaracteristica}
                handleOnCampoAlternativa={this.handleOnCampoAlternativa}
                handleOnCampoCaracteristica={this.handleOnCampoCaracteristica}
                articuloEdicion={this.props.dataArticulo.articuloCompleto}


                esEdicion={this.props.match && this.props.match.params && this.props.match.params.idArticulo ? true : false}

                clearState={this.state.clearState}
                valid={this.state.valid}
                errorDescription={this.state.errorDescription}
                onChangeFalseEditorState={this.onChangeFalseEditorState}
                openModalImagen={this.state.openModalImagen}
                imagenOriginal={this.state.imagenOriginal}
                handleOnSaveImagenCortada={this.handleOnSaveImagenCortada}
                ofertas={ofertas}
            />

        )
    }
}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        ...rubrosActions,
        ...articuloActions,
    }, dispatch)
}


function mapStateToProps(state) {
    return {
        rubros: rubrosDataSelector(state),
        dataArticulo: articuloDataSelector(state),
        dataSubrubro: rubrosDataSelector(state),
        imagenesArticulo: state.articuloReducer.getIn(["data", "articuloImagenes"]).toJS(),
        usuario: usuarioSelector(state),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ArticuloGenericoNuevoContainer)